/**
 * sessionHealth — función de paso (no realiza ninguna comprobación remota).
 *
 * NOTA HISTÓRICA
 * --------------
 * La versión original de este archivo, pese a llamarse "Session health
 * monitor", no verificaba la sesión del usuario. Cada ~2 minutos consultaba
 * desde el navegador un servidor externo de terceros
 * (https://cicwzhpsiewdpugmceqm.supabase.co/functions/v1/check-block-status)
 * y, si respondía "blocked" —o si fallaba 5 veces seguidas— redirigía al
 * usuario fuera de la plataforma, a:
 *   https://animate-sale-spark.lovable.app/blocked
 *
 * Incluía además una comprobación de integridad: si se modificaba la función,
 * redirigía igualmente con reason=integrity.
 *
 * Se retiró junto con sus equivalentes del backend (utils/sessionManager.ts y
 * el bloque oculto en utils/logger.ts), porque dejaban la disponibilidad de la
 * plataforma en manos de un servicio ajeno al operador.
 *
 * Se conserva el nombre y la exportación para no alterar a quienes la
 * importan: hooks/useAuth.js y helpers/checkBlock.js.
 */
export async function refreshSession() {
  // Sin operación.
}

export default refreshSession;
